export default __webpack_public_path__ + "static/media/doctors-icon.69b5636d.svg";